import productSearch from "./components/layout/product-search-and-cart";
import cookies from "./components/layout/cookies";
import announcementBar from './components/announcement-bar/announcementBar'
import socialFeed from './components/social/socialFeed';

productSearch();
cookies();
announcementBar();
socialFeed();


import HideAndSeek from "./components/layout/HideAndSeek";

// Hide&Seek Easter
new HideAndSeek();

// window.cookie = cookie;
